// @flow
import Resource from 'speed-js-core/src/api/Resource';

export default class NomenclatureItemResource extends Resource {
    basePath: string = 'nomenclatures/items/';

    /**
     * @param {string} ident: the code of the nomenclature
     */
    objectPath: string = 'nomenclatures/items/{ident}/';

    schema(code: string): Promise<Object> {
        return this.client._request(this._getObjectPath(code), 'OPTIONS')
            .then((response) => response.data);
    }
}
